import React, { useEffect, useState } from 'react';
import { Button } from 'antd-mobile';
import styles from './projectBrief.module.scss';
import { ApiCore } from '../../api/index';
import { Tabs } from 'antd-mobile';
import summaryBanner from '../../static/images_medicalLive/summary_banner2.png';
import introduceImg from '../../static/images_medicalLive/introduce.png';
import requestImg from '../../static/images_medicalLive/request.png';
import utils from '../../utils/utils';
import config from './config.json';

const api = new ApiCore();
const tabs = [
    { title: '活动介绍' },
    { title: '征集要求' }
];

let env = process.env.REACT_APP_ENV;

function ProjectBrief(props: any) {

    // 获取活动activityCode
    let activityCode = utils.getUrlParams().activityCode;

    // 活动介绍
    const [introduction, setIntroduction] = useState<any>('');
    // 征集要求
    const [request, setRequest] = useState<any>('');
    // 项目code
    const [projectCodes, setprojectCodes] = useState<any>('');
    // 租户code
    const [tenantCode, setTenantCode] = useState<any>('');
    // 活动code
    const [activiCode, setActiviCode] = useState<any>('');
    // 是否立即报名
    const [isSignup, setIsSignup] = useState<any>(true);
    // 活动logo
    const [logo, setLogo] = useState<any>('');
    useEffect(() => {
        document.title = '项目简介';
        getData()
        
    }, [])

    const getData = () => {
        let params = {
            activityCode: activityCode ? activityCode: 'YMTSP'
        }
        api.getProjectActivity(params).then((res: any) => {
            if (res.code == 0) {
                if (!res.data) {
                    return
                }
                setIsSignup(false)
                
                let data = res.data;
                setIntroduction(data.introduction)
                setRequest(data.request)

                setprojectCodes(data.projectCode)
                setTenantCode(data.tenantCode)
                setActiviCode(data.code)
                setLogo(data.logo)
                let YMTCodes = {
                    projectCodes: data.projectCode,
                    tenantCode: data.tenantCode,
                    activityCode: data.code,
                }
                sessionStorage.setItem('YMTCodes', JSON.stringify(YMTCodes))
            }
        });
    }

    /**
     * 立即报名
     */
    const onSignUp = () => {

        let param = `?projectCodes=${projectCodes}&tenantCode=${tenantCode}&activityCode=${activiCode}`
        let fromEdcDoctorHome = utils.getUrlParams().fromEdcDoctorHome || '';
        if (fromEdcDoctorHome) {
            param += `&fromEdcDoctorHome=${fromEdcDoctorHome}`;
        }
        if (env === 'development') {
            window.location.href = config.development + param
        }
        else if (env === 'test') {
            window.location.href = config.test + param
        }
        else if (env === 'production') {
            window.location.href = config.production + param
        }
    }

    return (
        <div className={`${styles.projectBrief_content}`}>
            <img src={logo?logo: summaryBanner} alt='' className={`${styles.summaryBanner}`} />
            <Tabs tabs={tabs}
                initialPage={0}
                onChange={(tab, index) => { console.log('onChange', index, tab); }}
                onTabClick={(tab, index) => { console.log('onTabClick', index, tab); }}
                tabBarUnderlineStyle={{ borderColor: 'rgb(65, 185, 121)', background: 'rgb(65, 185, 121)' }}
                tabBarBackgroundColor="#f5f5f9"
            >
                {/* 活动介绍 */}
                <div className={`${styles.tabsItem}`}>
                    <div className={styles.place_holder_content}></div>
                    <img src={introduceImg} alt='' className={`${styles.title}`} />
                    <div className={`${styles.con}`} dangerouslySetInnerHTML={{ __html: introduction || '暂无数据' }}></div>
                    <Button type="primary" onClick={onSignUp} disabled={isSignup}>点击立即报名</Button>
                </div>
                {/* 征集要求 */}
                <div className={`${styles.tabsItem}`}>
                    <div className={styles.place_holder_content}></div>
                    <img src={requestImg} alt='' className={`${styles.title}`} />
                    <div className={`${styles.con}`} dangerouslySetInnerHTML={{ __html: request || '暂无数据' }}></div>
                </div>
            </Tabs>
        </div>
    )

}

export default ProjectBrief;